import React from 'react';
import HighlightFeatureLabel from 'partial/HighlightFeatureLabel';
import { Link } from 'components/navigation/Link/Link';
import { INSURANCE_MARKETPLACE } from 'types/morph.pagePosition.constants';
import { getViewOfferTileCard } from 'helpers/tracking.helpers';
import { useSeenOfferPixel } from 'hook/helper.hook';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { stringToValidId } from 'helpers/string.helper';

const InsuranceTypeBadge = ({
  text,
  datatestid,
  onLinkClickCallback,
  url,
  icon,
  location,
  featureToHighlight,
  offerModulePosition,
  modulePosition,
  cardName,
  vertical,
}) => {
  let attributes = {
    moduleName: INSURANCE_MARKETPLACE,
    modulePosition: modulePosition,
    offerModulePosition: offerModulePosition,
    cardName: cardName,
    vertical: vertical,
  };

  let trackingAttributes = getViewOfferTileCard(attributes);

  const seenOffer = useSeenOfferPixel(trackingAttributes);
  const insuranceTypeBadgeId = stringToValidId(text);

  return (
    <div className="format33 m-format100 pad8">
      <Link
        onClickCallback={onLinkClickCallback}
        datatestid={`${datatestid}-link`}
        to={url}
        location={location}
        featureToHighlight={featureToHighlight}
        extraEventAttributes={trackingAttributes}
        className="bgWhite border-rad4px grayShadow16 format100"
        ariaLabelledby={insuranceTypeBadgeId}
      >
        <FlexContainer className="pad16 items-align-center ">
          <div>{icon}</div>
          <div id={insuranceTypeBadgeId} className="padL16 bold fontGray400">
            {text}
            {seenOffer}
          </div>
        </FlexContainer>
      </Link>
      {featureToHighlight && (
        <HighlightFeatureLabel featureToHighlight={featureToHighlight} />
      )}
    </div>
  );
};

export default InsuranceTypeBadge;
